import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'styled-components';

import { AuthProvider } from './context/auth';
import Routers from './lib/react-router-dom/router';
import GlobalStyle from './lib/styled-components/GlobalStyle';
import Theme from './lib/styled-components/Theme';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient({
	defaultOptions: { queries: { refetchOnWindowFocus: false } }, // 모든 쿼리에서 브라우저 창이 다시 포커스될 때마다 재호출 하지 않음
});

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<ThemeProvider theme={Theme}>
				<GlobalStyle />
				<ToastContainer autoClose={2500} theme="colored" hideProgressBar closeButton={false} />
				<AuthProvider>
					<Routers />
				</AuthProvider>
			</ThemeProvider>
		</QueryClientProvider>
	);
}

export default App;
